import { useCallback, useLayoutEffect, useRef, useState } from 'react';

// Use the complete authorized collection, never the filtered/paginated view.
export function useAuthorizedSelection<T extends { id: string }>(rows: readonly { id: string }[]) {
  const [selection, setSelection] = useState<T | null>(null);
  const allowed = useRef(new Set(rows.map((row) => row.id)));
  const mounted = useRef(false);
  useLayoutEffect(() => {
    mounted.current = true;
    allowed.current = new Set(rows.map((row) => row.id));
    setSelection((current) => (current && !allowed.current.has(current.id) ? null : current));
    return () => {
      mounted.current = false;
    };
  }, [rows]);
  const select = useCallback((next: T | null) => {
    if (mounted.current && (!next || allowed.current.has(next.id))) setSelection(next);
  }, []);
  // Hide revoked data during render, before effects run, as well as rejecting late responses.
  const visible = selection && rows.some((row) => row.id === selection.id) ? selection : null;
  return [visible, select] as const;
}
